// extracted by mini-css-extract-plugin
export default {"userContainer":"user-details-page-section_userContainer__SRXtJ","userDetailsItemContainer":"user-details-page-section_userDetailsItemContainer__e+Qp3"};